import { Card, Button } from '@/components';
import { R } from '@/features/booking/resources/Texts.resx';

export const NotifyOwnDoctor = ({
    onSelectNotifyOwnDoctor,
}: {
    onSelectNotifyOwnDoctor?: (accepted: boolean) => void;
}) => {
    return (
        <Card className="max-w-120" alwaysCard={false}>
            <h2 className="mb-6">{R.NotifyOwnDoctorHeader}</h2>
            <div className="mb-8">{R.NotifyOwnDoctorDescription}</div>
            <div className="flex w-full flex-row justify-between">
                <Button
                    className="ns:min-w-44 min-w-36"
                    variant="ghost"
                    onClick={() => onSelectNotifyOwnDoctor(false)}
                >
                    {R.No}
                </Button>
                <Button
                    className="ns:min-w-44 min-w-36"
                    variant="primary"
                    onClick={() => onSelectNotifyOwnDoctor(true)}
                >
                    {R.Yes}
                </Button>
            </div>
        </Card>
    );
};
